import { defineMessages } from 'react-intl';

import BaseSchemaExtender from './BaseSchemaExtender';
import { getMaxLengthProperty, MAX_LENGTH_FIELD } from './maxLength';
import { getSizeProperty, SIZE_FIELD } from './size';

// Mensagens i18n exclusivas do extensor de schema para campos numéricos.
const messages = defineMessages({
  field_min_value: {
    id: 'form_field_min_value',
    defaultMessage: 'Minimum accepted value',
  },
  field_min_value_description: {
    id: 'form_field_min_value_description',
    defaultMessage: 'Minimum numeric value allowed for this field.',
  },
  field_max_value: {
    id: 'form_field_max_value',
    defaultMessage: 'Maximum accepted value',
  },
  field_max_value_description: {
    id: 'form_field_max_value_description',
    defaultMessage: 'Maximum numeric value allowed for this field.',
  },
});

/**
 * Schema extender para campos do tipo número.
 * Estende o BaseSchemaExtender adicionando valor mínimo e máximo.
 */
export const NumberSchemaExtender = (intl) => {
  const base = BaseSchemaExtender(intl);

  return {
    fields: [
      ...base.fields,
      'min_value',
      'max_value',
      MAX_LENGTH_FIELD,
      SIZE_FIELD,
    ],
    properties: {
      ...base.properties,
      min_value: {
        title: intl.formatMessage(messages.field_min_value),
        description: intl.formatMessage(messages.field_min_value_description),
        type: 'number',
      },
      max_value: {
        title: intl.formatMessage(messages.field_max_value),
        description: intl.formatMessage(messages.field_max_value_description),
        type: 'number',
      },
      [MAX_LENGTH_FIELD]: getMaxLengthProperty(intl),
      [SIZE_FIELD]: getSizeProperty(intl),
    },
    required: [...base.required],
  };
};

export default NumberSchemaExtender;
